import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42mWNQQqAMBAD+/8vigcFoSh4kWq3zSaK2IM0EAjDQIK+kBAsvaWjYYS2HKa0zzrWQV5zL+CBW5wUl1HVrl4gXcVOlfy/uAFxLn2/UcG+MQAAAABJRU5ErkJggg=="};
